/**
 * https://react-redux.js.org/api/hooks#useselector
 */
import {useSelector} from "react-redux";
import {useMemo} from "react";
import {ParametersManager} from "core/parameters/ParametersManager";

const getUser = (state: any) => state.user

export default function  usePlatformParams(): ParametersManager{
  const currentAccount = useSelector(getUser)
  return useMemo(()=> {
    return new ParametersManager(currentAccount, currentAccount.settings,currentAccount.tenant)
  },[currentAccount])
}
